import React from "react"
import classes from "./CheckboxFilterTag.module.css"
import { CloseFab } from "../../../../../ui/atoms/Fab"

interface Props {
  label: string
  onRemove: () => void
}

const CheckboxFilterTag = ({ label, onRemove }: Props) => {
  return (
    <div className={classes.root}>
      {label}
      <CloseFab
        colorValue="transparent"
        size="small"
        className={classes.close}
        iconClassName={classes.closeIcon}
        onClick={onRemove}
      />
    </div>
  )
}

export default CheckboxFilterTag
